import React from "react";

function InfoPopup({ image }) {
  return (
    <div
      style={{
        width: "100vw",
        height: "100vh",
        boxSizing: "border-box",
        padding: "24px 8px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{
          width: "30%",
          maxWidth: "900px",
          paddingRight: "0px",
          paddingLeft: "80px",
        }}
      >
        <img
          src={"/assets/walkthrough/ECHO_green.svg"}
          alt="ECHO and ESA Logos"
          style={{
            width: "100%",
            height: "auto",
            display: "block",
          }}
        />
      </div>
      <div
        style={{
          background: "#fff",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          width: "80%",
          maxWidth: 800,
          minHeight: 180,
          margin: "40px 100px",
          padding: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={image}
          alt="Scenario Illustration"
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </div>
    </div>
  );
}

export default InfoPopup;
